/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
// import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SEND_PURCHASE_REFERALS } from "../graphql";
import { VApplication } from "../../../application";
// import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";
import config from "../config/useremail.config.json";
import { GetOpenReg } from "../graphql";
const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface SendPurchaseInviteUserProps {
  // presentation: any;
  // section?: any;
  // type?: any;
  // email?: any;
  presentation?: any;
  sectionOptType?: any;
  email?: any;
  partition?: any;
  inviteType?: any;
}
export interface ISendPurchaseInviteMethods extends IPluginMethodMap {
  sendPurchaseInviteUser(args: SendPurchaseInviteUserProps): Promise<any>;
}

export class SendPurchaseInviteUserService implements IAgentPlugin {
  readonly methods: ISendPurchaseInviteMethods;

  constructor() {
    this.methods = {
      sendPurchaseInviteUser: this.sendPurchaseInviteUser.bind(this),
    };
  }

  async sendPurchaseInviteUser(args: SendPurchaseInviteUserProps) {
    console.log("in send purchase=====>");
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // const sendInvite = this.createInviteObjects(args);
    const { presentation, sectionOptType, email, partition, inviteType, code } =
      args;

    console.log(
      "sendPurchaseInviteUser----->",
      email,
      partition,
      sectionOptType,
      inviteType
    );
    try {
      if (client) {
        const id = await client.query({
          query: GetOpenReg,
          variables: {},
          fetchPolicy: "network-only",
        });
        if (id?.data) {
          console.log(id?.data)
          const res = await client.mutate({
            mutation: SEND_PURCHASE_REFERALS,
            variables: {
              data: {
                email: email,
                inviteType: inviteType,
                sectionOptType: sectionOptType,
                partition: partition,
              },
              openRegId: id?.data?.getOpenReg?.openRegID,
              referralCode: code,
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data) {
            return {
              ...res?.data?.sendPurchaseReferals,
            };
          }
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
}
